

























































































import { EditorialProject as ProjectObj, ProjectProductsResult } from '@/models'
import ApiClient from '@/services/api-client'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { ActionTypes } from '@/store/action-types'
import { MutationTypes } from '@/store/mutation-types'
import ApiGtag, { Category } from '@/services/api-gtag'

@Component
export default class Project extends Vue {
  private project: ProjectObj = { id: '', name: '', image: '', totalProducts: 0 }
  private projectId = ''
  private defaultPageSize = 10
  private currentPage = 1
  private result: ProjectProductsResult = { totalResults: 0, pageSize: 0, pageOffset: 0, items: [] }

  @Watch('currentPage')
  onCurrentPageChanged(value: string, oldValue: string) {
    if (value !== oldValue) {
      this.loadEditorialProject()
    }
  }

  created() {
    this.projectId = this.$router.currentRoute.params.projectId
    this.loadEditorialProject()
  }

  private loadEditorialProject() {
    this.loadEditorialProjectInfo(this.projectId)
      .then(project => {
        this.project = project
        return this.loadEditorialProjectProducts(this.projectId)
      })
      .then(result => {
        this.result = result
      })
  }

  private async loadEditorialProjectInfo(projectId: string) {
    return ApiClient.getEditorialProject(projectId).then(project => {
      ApiGtag.sendEvent(Category.Project, 'View project', `${project.id}/${project.name}`)
      this.$store.commit(MutationTypes.SET_ACTIVE_PROJECT, this.project)
      if (this.$route.name === 'Project') {
        window.document.title = `${this.$i18n.t('pageTitle.project')} ${project.name} - LDX`
      }
      return project
    })
  }

  private async loadEditorialProjectProducts(projectId: string) {
    const offset = (this.currentPage - 1) * this.defaultPageSize
    return ApiClient.getEditorialProjectProducts(projectId, this.defaultPageSize, offset)
  }

  public toggleFavoriteCourse(product: { id: any }): void {
    this.$store.dispatch(ActionTypes.STORE_FAVORITE_COURSES, product)
  }
}
